"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @TODO - Debug _execFn

var _fill = function _fill(arr, val) {
  return arr.fill(val);
};

exports.default = _fill;